<template>
  <div id="history-detail" class="content">
    <div>
      <h2 class="page-title">発注履歴詳細</h2>

      <div class="row mx-1">
        <div class="col-6">
          <b-button class="btn-secondary sp-fs-14 col-8 col-md-4" @click="back">
            もどる
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            class="btn-secondary sp-fs-14"
            v-if="
              isEditTorihiki &&
              Number(syaryoDetail.syaryo_SYARYO_STATUS) === 1 &&
              !syaryoDetail.syaryo_KANRI_BANGO
            "
            @click="isCancelConfirm = true"
          >
            発注キャンセル
          </b-button>
          <b-button
            class="btn-secondary sp-fs-14"
            v-if="Number(syaryoDetail.syaryo_SYARYO_STATUS) === 9"
            @click="isCancelConfirm = true"
            disabled
          >
            キャンセル済み
          </b-button>
        </div>
      </div>
      <md-dialog-confirm
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isCancelConfirm"
        md-title=""
        md-content="<strong>対象車両の発注をキャンセルしてもよろしいですか？</strong>"
        md-confirm-text="はい"
        md-cancel-text="いいえ"
        @md-confirm="orderCancel"
      />
      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isCanceled"
        md-content="<strong>発注をキャンセルしました。</strong>"
      />

      <h4 class="page-sub-title pl-2 pl-md-4">基本情報</h4>
      <section id="history-detail-base">
        <div class="section-child">
          <table class="table">
            <tr>
              <th><span>輸送</span></th>
              <td>
                <span>
                  {{ isMeihen ? '名変輸送' : '通常輸送' }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>ステータス</span></th>
              <td>
                <span>
                  {{
                    getText(
                      syaryoStatus,
                      Number(syaryoDetail.syaryo_SYARYO_STATUS)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>貴社管理番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_KISYA_KANRI_BANGO }}</span>
              </td>
            </tr>
            <tr>
              <th><span>ロジコ管理番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_KANRI_BANGO }}</span>
              </td>
            </tr>
            <tr>
              <th><span>ご注文日</span></th>
              <td>
                <span>{{ dateFormat(syaryoDetail.syaryo_JYUCHU_BI) }}</span>
              </td>
            </tr>
            <tr>
              <th><span>合算料金</span></th>
              <td>
                <span
                  v-if="
                    !Number($store.state.user.data.hum_torihiki.NAVI_RYOKIN_FLG)
                  "
                >
                  {{
                    syaryoDetail.uchiwake_RYOKIN_SUM
                      ? separateComma(syaryoDetail.uchiwake_RYOKIN_SUM)
                      : 0
                  }}
                  円
                  <b-button
                    class="btn-success ml-3 break-down-btn sp-fs-14"
                    @click="getUchiwake($route.params.id)"
                  >
                    内訳
                  </b-button>
                </span>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">引取情報</h4>
      <section id="history-detail-hikitori">
        <div class="section-child">
          <table class="table">
            <tr>
              <th>
                <span>引取予定日</span>
              </th>
              <td>
                <span>
                  {{ syaryoDetail.hikitoriyoteibi }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>名称</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_MEI }}</span>
              </td>
            </tr>
            <tr>
              <th><span>住所</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.jyucyu_HIKITORI_YUBIN1 &&
                    syaryoDetail.jyucyu_HIKITORI_YUBIN2
                  "
                >
                  {{ syaryoDetail.jyucyu_HIKITORI_YUBIN1 }}-{{
                    syaryoDetail.jyucyu_HIKITORI_YUBIN2
                  }}
                  <br />
                </span>
                <span>
                  {{ syaryoDetail.jyucyu_HIKITORI_TODO_MEI
                  }}{{ syaryoDetail.jyucyu_HIKITORI_SHIKU_MEI
                  }}{{ syaryoDetail.jyucyu_HIKITORI_BANCHI }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriDirect || syaryoDetail.jyucyu_HIKITORI_TEL">
              <th><span>TEL</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_TEL }}</span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriDirect ||
                (!isHikitoriMaster && syaryoDetail.jyucyu_HIKITORI_TANTO_MEI)
              "
            >
              <th><span>担当者名</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_TANTO_MEI }}</span>
              </td>
            </tr>
            <tr
              v-if="isHikitoriDirect || syaryoDetail.jyucyu_HIKITORI_TANTO_TEL"
            >
              <th><span>担当者TEL</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_TANTO_TEL }}</span>
              </td>
            </tr>
            <tr
              v-if="isHikitoriDirect || syaryoDetail.jyucyu_HIKITORI_YUSO_KBN"
            >
              <th><span>種別</span></th>
              <td>
                <span>
                  {{
                    getText(yusoKbnList, syaryoDetail.jyucyu_HIKITORI_YUSO_KBN)
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="isHikitoriDirect || syaryoDetail.jyucyu_HIKITORI_TEIKYU_BI"
            >
              <th><span>定休日</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_TEIKYU_BI }}</span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriDirect ||
                syaryoDetail.jyucyu_HIKITORI_EIGYO_KAISI_JIKAN ||
                syaryoDetail.jyucyu_HIKITORI_EIGYO_SYURYO_JIKAN
              "
            >
              <th><span>営業時間</span></th>
              <td>
                <span>
                  {{ syaryoDetail.jyucyu_HIKITORI_EIGYO_KAISI_JIKAN }}
                  <span
                    v-if="
                      syaryoDetail.jyucyu_HIKITORI_EIGYO_KAISI_JIKAN ||
                      syaryoDetail.jyucyu_HIKITORI_EIGYO_SYURYO_JIKAN
                    "
                  >
                    〜
                  </span>
                  {{ syaryoDetail.jyucyu_HIKITORI_EIGYO_SYURYO_JIKAN }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>ワンプラ落札</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoList,
                      Number(syaryoDetail.jyucyu_HIKITORI_AA_WANPULA_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriAA &&
                Number(syaryoDetail.jyucyu_HIKITORI_AA_WANPULA_FLG)
              "
            >
              <th><span>落札日</span></th>
              <td>
                <span>
                  {{
                    dateFormat(
                      syaryoDetail.jyucyu_HIKITORI_AA_WANPULA_RAKUSATU_BI
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriAA &&
                !Number(syaryoDetail.jyucyu_HIKITORI_AA_WANPULA_FLG)
              "
            >
              <th><span>オークション開催日</span></th>
              <td>
                <span>
                  {{ dateFormat(syaryoDetail.jyucyu_HIKITORI_AA_KAISAI_BI) }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>流札車両</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoList,
                      Number(syaryoDetail.jyucyu_HIKITORI_AA_RYUSATU_SYARYO)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>POS種別（会員種別）</span></th>
              <td>
                <span>
                  {{
                    getText(posKbnList, syaryoDetail.jyucyu_HIKITORI_AA_POS_KBN)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>代行業社名</span></th>
              <td>
                <span>
                  {{ syaryoDetail.jyucyu_HIKITORI_AA_POS_DAIKO_GYOSHA_MEI }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>名義情報</span></th>
              <td>
                <span>
                  {{ syaryoDetail.jyucyu_HIKITORI_AA_POS_MEIGI_INFO }}
                </span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>POS番号（会員番号）</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_AA_POS_BANGO }}</span>
              </td>
            </tr>
            <tr v-if="isHikitoriAA">
              <th><span>入金状況</span></th>
              <td>
                <span>
                  {{
                    getText(
                      aaNyukinJyokyoKbnList,
                      Number(syaryoDetail.jyucyu_HIKITORI_AA_NYUKIN_JYOKYO_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriAA && syaryoDetail.jyucyu_HIKITORI_AA_NYUKIN_YOTEI_BI
              "
            >
              <th><span>入金予定日</span></th>
              <td>
                <span>
                  {{
                    dateFormat(syaryoDetail.jyucyu_HIKITORI_AA_NYUKIN_YOTEI_BI)
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriAA &&
                syaryoDetail.jyucyu_HIKITORI_AA_HANSHUTU_KANOU_BI
              "
            >
              <th><span>搬出可能日</span></th>
              <td>
                <span>
                  {{
                    dateFormat(
                      syaryoDetail.jyucyu_HIKITORI_AA_HANSHUTU_KANOU_BI
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isHikitoriAA &&
                Number(syaryoDetail.jyucyu_HIKITORI_AA_NYUKIN_JYOKYO_KBN) === 3
              "
            >
              <th><span>入金予定時間</span></th>
              <td>
                <span>
                  {{ syaryoDetail.jyucyu_HIKITORI_AA_NYUKIN_YOTEI_JIKAN }}
                </span>
              </td>
            </tr>
            <template>
              <tr>
                <th>
                  <span>引取希望日</span>
                </th>
                <td>
                  <div>
                    {{ hikitoriKibouBiType }}
                  </div>
                  <div v-if="isHikitoriKibouDateTimeVisible">
                    {{ dateFormat(syaryoDetail.jyucyu_HIKITORI_KIBOU_BI) }}
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>引取希望時間</span>
                </th>
                <td>
                  <div>
                    {{ hikitoriKibouJikanType }}
                  </div>
                  <div v-if="isHikitoriKibouJikanReasonVisible">
                    {{ syaryoDetail.jyucyu_HIKITORI_KIBOU_JIKAN_REASON }}
                  </div>
                </td>
              </tr>
            </template>
            <tr>
              <th>
                <span>引取前の事前連絡</span>
              </th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.jyucyu_HIKITORI_JIZEN_RENRAKU_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>備考</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_HIKITORI_BIKOU }}</span>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">納車情報</h4>
      <section id="history-detail-nosya">
        <div class="section-child">
          <table class="table">
            <tr>
              <th>
                <span>納車予定日</span>
              </th>
              <td>
                <span>
                  {{ syaryoDetail.nosyayoteibi }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>名称</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_MEI }}</span>
              </td>
            </tr>
            <tr>
              <th><span>住所</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.jyucyu_NOSYA_YUBIN1 &&
                    syaryoDetail.jyucyu_NOSYA_YUBIN2
                  "
                >
                  {{ syaryoDetail.jyucyu_NOSYA_YUBIN1 }}-{{
                    syaryoDetail.jyucyu_NOSYA_YUBIN2
                  }}
                  <br />
                </span>
                <span>
                  {{ syaryoDetail.jyucyu_NOSYA_TODO_MEI
                  }}{{ syaryoDetail.jyucyu_NOSYA_SHIKU_MEI
                  }}{{ syaryoDetail.jyucyu_NOSYA_BANCHI }}
                </span>
              </td>
            </tr>
            <tr v-if="isNosyaDirect || syaryoDetail.jyucyu_NOSYA_TEL">
              <th><span>TEL</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_TEL }}</span>
              </td>
            </tr>
            <tr
              v-if="
                isNosyaDirect ||
                (!isNosyaMaster && syaryoDetail.jyucyu_NOSYA_TANTO_MEI)
              "
            >
              <th><span>担当者名</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_TANTO_MEI }}</span>
              </td>
            </tr>
            <tr v-if="isNosyaDirect || syaryoDetail.jyucyu_NOSYA_TANTO_TEL">
              <th><span>担当者TEL</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_TANTO_TEL }}</span>
              </td>
            </tr>
            <tr v-if="isNosyaDirect || syaryoDetail.jyucyu_NOSYA_YUSO_KBN">
              <th><span>種別</span></th>
              <td>
                <span>
                  {{ getText(yusoKbnList, syaryoDetail.jyucyu_NOSYA_YUSO_KBN) }}
                </span>
              </td>
            </tr>
            <tr v-if="isNosyaDirect || syaryoDetail.jyucyu_NOSYA_TEIKYU_BI">
              <th><span>定休日</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_TEIKYU_BI }}</span>
              </td>
            </tr>
            <tr
              v-if="
                isNosyaDirect ||
                syaryoDetail.jyucyu_NOSYA_EIGYO_KAISI_JIKAN ||
                syaryoDetail.jyucyu_NOSYA_EIGYO_SYURYO_JIKAN
              "
            >
              <th><span>営業時間</span></th>
              <td>
                <span>
                  {{ syaryoDetail.jyucyu_NOSYA_EIGYO_KAISI_JIKAN }}
                  <span
                    v-if="
                      syaryoDetail.jyucyu_NOSYA_EIGYO_KAISI_JIKAN ||
                      syaryoDetail.jyucyu_NOSYA_EIGYO_SYURYO_JIKAN
                    "
                  >
                    〜
                  </span>
                  {{ syaryoDetail.jyucyu_NOSYA_EIGYO_SYURYO_JIKAN }}
                </span>
              </td>
            </tr>
            <tr v-if="isNosyaAA">
              <th><span>オークション開催日</span></th>
              <td>
                <span>
                  {{ dateFormat(syaryoDetail.jyucyu_NOSYA_AA_KAISAI_BI) }}
                </span>
              </td>
            </tr>
            <tr v-if="isNosyaAA">
              <th><span>POS種別（会員種別）</span></th>
              <td>
                <span>
                  {{
                    getText(posKbnList, syaryoDetail.jyucyu_NOSYA_AA_POS_KBN)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isNosyaAA">
              <th><span>代行業社名</span></th>
              <td>
                <span>
                  {{ syaryoDetail.jyucyu_NOSYA_AA_POS_DAIKO_GYOSHA_MEI }}
                </span>
              </td>
            </tr>
            <tr v-if="isNosyaAA">
              <th><span>名義情報</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_AA_POS_MEIGI_INFO }}</span>
              </td>
            </tr>
            <tr v-if="isNosyaAA">
              <th><span>POS番号（会員番号）</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_AA_POS_BANGO }}</span>
              </td>
            </tr>
            <template>
              <tr>
                <th>
                  <span>納車希望日</span>
                </th>
                <td>
                  <div>
                    {{ nosyaKibouBiType }}
                  </div>
                  <div v-if="isNosyaKibouDateTimeVisible">
                    {{ dateFormat(syaryoDetail.jyucyu_NOSYA_KIBOU_BI) }}
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>納車希望時間</span>
                </th>
                <td>
                  <div>
                    {{ nosyaKibouJikanType }}
                  </div>
                  <div v-if="isNosyaKibouJikanReasonVisible">
                    {{ syaryoDetail.jyucyu_NOSYA_KIBOU_JIKAN_REASON }}
                  </div>
                </td>
              </tr>
            </template>
            <tr>
              <th>
                <span>納車前の事前連絡</span>
              </th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      syaryoDetail.jyucyu_NOSYA_JIZEN_RENRAKU_FLG
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>備考</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_NOSYA_BIKOU }}</span>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">車両情報</h4>
      <section id="history-detail-syaryo">
        <div class="section-child">
          <table class="table">
            <tr>
              <th><span>メーカー名</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SYARYO_MAKER_MEI }}</span>
              </td>
            </tr>
            <tr>
              <th><span>車両タイプ</span></th>
              <td>
                <span>
                  {{ syaryoTypeKbnJson[syaryoDetail.syaryo_SYARYO_TYPE_KBN] }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_SYARYO_TYPE_DETAIL !== null">
              <th><span>車両タイプ その他詳細</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_SYARYO_TYPE_DETAIL }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_SYARYO_SHAPE_TYPE !== null">
              <th><span>車両形状</span></th>
              <td>
                <span>
                  {{
                    syaryoShapeTypeJson[syaryoDetail.syaryo_SYARYO_SHAPE_TYPE]
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_SYARYO_SHAPE_DETAIL !== null">
              <th><span>車両形状 その他詳細</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_SYARYO_SHAPE_DETAIL }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>車名</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SYARYO_MEI }}</span>
              </td>
            </tr>
            <tr>
              <th><span>車台番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SYADAI_BANGO }}</span>
              </td>
            </tr>
            <tr>
              <th><span>登録番号</span></th>
              <td>
                <span>
                  {{
                    syaryoDetail.syaryo_TOUROKU_BANGO
                      ? syaryoDetail.syaryo_TOUROKU_BANGO.replace(/ /g, '-')
                      : ''
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>長さ・幅・高さ(cm)</span></th>
              <td>
                <label v-if="syaryoDetail.syaryo_SYARYO_NAGASA">長さ</label>
                <span v-if="syaryoDetail.syaryo_SYARYO_NAGASA">
                  {{ syaryoDetail.syaryo_SYARYO_NAGASA }}cm &nbsp;
                </span>
                <label v-if="syaryoDetail.syaryo_SYARYO_HABA">幅</label>
                <span v-if="syaryoDetail.syaryo_SYARYO_HABA">
                  {{ syaryoDetail.syaryo_SYARYO_HABA }}cm &nbsp;
                </span>
                <label v-if="syaryoDetail.syaryo_SYARYO_TAKASA">高さ</label>
                <span v-if="syaryoDetail.syaryo_SYARYO_TAKASA">
                  {{ syaryoDetail.syaryo_SYARYO_TAKASA }}cm &nbsp;
                </span>
              </td>
            </tr>

            <tr>
              <th><span>積載量・重量(kg)</span></th>
              <td>
                <label v-if="syaryoDetail.syaryo_SYARYO_SEKISAIRYO">
                  積載量
                </label>
                <span v-if="syaryoDetail.syaryo_SYARYO_SEKISAIRYO">
                  {{ syaryoDetail.syaryo_SYARYO_SEKISAIRYO }}kg &nbsp;
                </span>
                <label v-if="syaryoDetail.syaryo_SYARYO_JYURYO">重量</label>
                <span v-if="syaryoDetail.syaryo_SYARYO_JYURYO">
                  {{ syaryoDetail.syaryo_SYARYO_JYURYO }}kg &nbsp;
                </span>
              </td>
            </tr>

            <tr>
              <th><span>貴社管理番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_KISYA_KANRI_BANGO }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen">
              <th><span>下取り車両</span></th>
              <td>
                <span>
                  {{
                    getText(
                      ariNasiList,
                      Number(syaryoDetail.syaryo_SHITADORI_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="Number(syaryoDetail.syaryo_SHITADORI_FLG)">
              <th><span>下取り車両 輸送先</span></th>
              <td>
                <div>
                  {{
                    getText(
                      isLease ? yusosakiLeaseList : yusosakiList,
                      Number(syaryoDetail.syaryo_YUSOSAKI_KBN)
                    )
                  }}
                </div>
                <div v-if="syaryoDetail.syaryo_YUSOSAKI_FREE">
                  {{ syaryoDetail.syaryo_YUSOSAKI_FREE }}
                </div>
              </td>
            </tr>
            <tr
              v-if="
                !Number(isLease) &&
                Number(syaryoDetail.syaryo_SHITADORI_FLG) &&
                Number(syaryoDetail.syaryo_YUSOSAKI_KBN) === 1 &&
                syaryoDetail.syaryo_SOUFUSAKI_KBN !== null
              "
            >
              <th><span>下取り車両 書類の送付先</span></th>
              <td>
                <span>
                  {{
                    getText(
                      docSoufusakiList,
                      Number(syaryoDetail.syaryo_SOUFUSAKI_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                !Number(isLease) &&
                Number(syaryoDetail.syaryo_SHITADORI_FLG) &&
                Number(syaryoDetail.syaryo_YUSOSAKI_KBN) === 1 &&
                syaryoDetail.syaryo_SOUFUBUTU_KBN !== null
              "
            >
              <th><span>下取り車両 書類の送付物</span></th>
              <td>
                <span>
                  {{
                    getText(docSoufubutuList, syaryoDetail.syaryo_SOUFUBUTU_KBN)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && Number(syaryoDetail.syaryo_SHITADORI_FLG)">
              <th><span>下取り車両タイプ</span></th>
              <td>
                <span>
                  {{
                    getText(
                      syaryoTypeKbnList,
                      Number(syaryoDetail.syaryo_SHITADORI_SYARYO_TYPE_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && Number(syaryoDetail.syaryo_SHITADORI_FLG)">
              <th><span>下取りメーカー名</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_SHITADORI_SYARYO_MAKER_MEI }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && Number(syaryoDetail.syaryo_SHITADORI_FLG)">
              <th><span>下取り車名</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SHITADORI_SYARYO_MEI }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen && Number(syaryoDetail.syaryo_SHITADORI_FLG)">
              <th><span>下取り車台番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SHITADORI_SYADAI_BANGO }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen && Number(syaryoDetail.syaryo_SHITADORI_FLG)">
              <th><span>下取り登録番号</span></th>
              <td>
                <span>
                  {{
                    syaryoDetail.syaryo_SHITADORI_TOUROKU_BANGO
                      ? syaryoDetail.syaryo_SHITADORI_TOUROKU_BANGO.replace(
                          / /g,
                          '-'
                        )
                      : ''
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>車検の有無</span></th>
              <td>
                <span>
                  {{
                    getText(ariNasiList, Number(syaryoDetail.syaryo_SYAKEN_FLG))
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_SYUPPIN_BANGO">
              <th><span>出品番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SYUPPIN_BANGO }}</span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_SYUPPIN_BANGO">
              <th><span>搬出券</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_HANSYUTUKEN_URL ? 'あり' : '' }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_HANNYU_MEI">
              <th><span>搬入名義</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_HANNYU_MEI }}</span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_HANNYU_MEI">
              <th><span>扱い名</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_ATSUKAI_MEI }}</span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_HANNYU_MEI">
              <th><span>向け地</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MUKETI_MEI }}</span>
              </td>
            </tr>
            <tr v-if="isLease || isMeihen">
              <th><span>自走してもよろしいですか？</span></th>
              <td>
                <span>
                  {{
                    getText(jisouKbnList, Number(syaryoDetail.syaryo_JISOU_KBN))
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="conditions.is_self_run !== undefined">
              <th><span>公道を自力で自走できますか？</span></th>
              <td>
                <span>{{ yesNoFumeiJson[conditions.is_self_run] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_self_run_detail !== undefined">
              <th><span>自走できない理由を選択してください</span></th>
              <td>
                <span>
                  {{
                    carConditionNotSelfRunForReasonJson[
                      conditions.is_self_run_detail
                    ]
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="conditions.is_roll_tire !== undefined">
              <th><span>タイヤは転がりますか？</span></th>
              <td>
                <span>{{ yesNoFumeiJson[conditions.is_roll_tire] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_run_engine !== undefined">
              <th><span>エンジンはかかりますか？</span></th>
              <td>
                <span>{{ yesNoFumeiJson[conditions.is_run_engine] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_self_run_detail_other !== undefined">
              <th><span>その他詳細</span></th>
              <td>
                <span>{{ conditions.is_self_run_detail_other }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_studless !== undefined">
              <th><span>スタッドレスタイヤ装着済です</span></th>
              <td>
                <span>{{ yesNoFumeiJson[conditions.is_studless] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_run_air_conditioner !== undefined">
              <th><span>エアコン故障・不良車両ではありません</span></th>
              <td>
                <span>
                  {{ yesNoFumeiJson[conditions.is_run_air_conditioner] }}
                </span>
              </td>
            </tr>
            <tr v-if="conditions.is_custom !== undefined">
              <th><span>車両改造有無</span></th>
              <td>
                <span>{{ isCarCustomJson[conditions.is_custom] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_custom_details !== undefined">
              <th><span>該当する改造・架装</span></th>
              <td>
                <span
                  v-for="custom_detail in conditions.is_custom_details"
                  :key="custom_detail"
                >
                  {{ carCustomJson[custom_detail] }}
                </span>
              </td>
            </tr>
            <tr v-if="conditions.minimum_height !== undefined">
              <th><span>最低地上高</span></th>
              <td>
                <span>{{ conditions.minimum_height }} cm</span>
              </td>
            </tr>
            <tr v-if="conditions.inch_up !== undefined">
              <th><span>アップしたインチ数</span></th>
              <td>
                <span>{{ conditions.inch_up }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_custom_detail_other !== undefined">
              <th><span>その他詳細</span></th>
              <td>
                <span>{{ conditions.is_custom_detail_other }}</span>
              </td>
            </tr>
            <tr v-if="conditions.is_expensive !== undefined">
              <th><span>高額車ですか？</span></th>
              <td>
                <span>{{ isExpensiveCarJson[conditions.is_expensive] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.price !== undefined">
              <th><span>価格</span></th>
              <td>
                <span>{{ conditions.price }} 万円</span>
              </td>
            </tr>
            <tr v-if="conditions.is_classic !== undefined">
              <th><span>旧車ですか？</span></th>
              <td>
                <span>{{ isClassicCarJson[conditions.is_classic] }}</span>
              </td>
            </tr>
            <tr v-if="conditions.model_year !== undefined">
              <th><span>年式</span></th>
              <td>
                <span>{{ conditions.model_year }}</span>
              </td>
            </tr>
            <tr v-if="conditions.fuel_type !== undefined">
              <th><span>車両燃料</span></th>
              <td>
                <span>{{ carFuelJson[conditions.fuel_type] }}</span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_JYOTAI_FLG">
              <th><span>以下の項目に当てはまりますか？</span></th>
              <td>
                <span>
                  {{
                    getText(yesNoList, Number(syaryoDetail.syaryo_JYOTAI_FLG))
                  }}
                </span>
                <div class="mt-3">
                  <ul>
                    <li v-if="!isMeihen && !isLease">
                      自走不可（不動車・新古車）
                    </li>
                    <li>ローダウン（地面からの距離15cm以下）</li>
                    <li>高額車（車両価格500万円以上）</li>
                    <li>クラシックカー（製造年が1989年以前）</li>
                    <li>改造車（車検が通らないもの）</li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>登録希望日</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_KIBO_BI }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>車検残の有無</span></th>
              <td>
                <span>
                  {{
                    getText(
                      syakenList,
                      Number(syaryoDetail.syaryo_MEIHEN_SYAKEN_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen">
              <th><span>軽自動車ですか？</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoList,
                      Number(syaryoDetail.syaryo_MEIHEN_KEI_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>管轄運輸支局・検査登録事務所</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_MEIHEN_UNYU_SIKYOKU_SHIKU_MEI }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isMeihen &&
                !isLease &&
                syaryoDetail.syaryo_MEIHEN_TOUROKU_KBN !== '' &&
                syaryoDetail.syaryo_MEIHEN_TOUROKU_KBN !== null
              "
            >
              <th><span>登録種別</span></th>
              <td>
                <span>
                  {{
                    convMeihenTorokuKbn(syaryoDetail.syaryo_MEIHEN_TOUROKU_KBN)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>ナンバー種別</span></th>
              <td>
                <span>
                  {{
                    convMeihenNumberKbn(syaryoDetail.syaryo_MEIHEN_NUMBER_KBN)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen">
              <th><span>希望番号</span></th>
              <td>
                <span>
                  {{
                    convAriNasiFlg(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_FLG)
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isMeihen && Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_FLG)
              "
            >
              <th><span>希望番号の申請代行を希望しますか？</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_DAIKO_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isMeihen &&
                Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_FLG) &&
                Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_DAIKO_FLG)
              "
            >
              <th><span>希望する番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER }}</span>
              </td>
            </tr>
            <tr
              v-if="
                isMeihen &&
                Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_FLG) &&
                Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_DAIKO_FLG)
              "
            >
              <th><span>図柄入りナンバー</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_ZUGARA_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                isMeihen &&
                Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_FLG) &&
                !Number(syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_DAIKO_FLG)
              "
            >
              <th><span>受付番号</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_MEIHEN_KIBO_NUMBER_UKETUKE_BANGO }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>課税対象</span></th>
              <td>
                <span>
                  {{
                    getText(
                      kazeiList,
                      Number(syaryoDetail.syaryo_MEIHEN_KAZEI_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>新所有者名</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_SYOYUSYA_MEI }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen">
              <th><span>新使用者名</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_MEI }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen && isLease">
              <th><span>新使用者名(ふりがな)</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_MEI_KANA }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen && isLease">
              <th><span>新使用者 住所</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.syaryo_MEIHEN_SIYOSYA_YUBIN1 &&
                    syaryoDetail.syaryo_MEIHEN_SIYOSYA_YUBIN2
                  "
                >
                  {{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_YUBIN1 }}-{{
                    syaryoDetail.syaryo_MEIHEN_SIYOSYA_YUBIN2
                  }}
                  <br />
                </span>
                <span>
                  {{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_TODO_MEI
                  }}{{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_SHIKU_MEI
                  }}{{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_BANCHI }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && isLease">
              <th><span>新使用者 TEL</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_TEL }}</span>
              </td>
            </tr>
            <tr v-if="isMeihen && isLease">
              <th><span>新使用者 メールアドレス</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_MEIHEN_SIYOSYA_MAIL_ADDR }}</span>
              </td>
            </tr>

            <tr v-if="isMeihen && !isLease">
              <th><span>車庫証明取得代行</span></th>
              <td>
                <span>
                  {{
                    getText(
                      syakoDaikoList,
                      Number(syaryoDetail.syaryo_MEIHEN_SYAKOSYO_DAIKO_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <!-- LOGI_NAVI-89: 自賠責項目は廃止済み。MEIHEN_JIBAISEKI_KBN[0] = '' 定義より、データあり（コード値1以上）の場合のみ表示する -->
            <tr
              v-if="
                isMeihen &&
                !isLease &&
                Number(syaryoDetail.syaryo_MEIHEN_JIBAISEKI_KBN) > 0
              "
            >
              <th><span>自賠責</span></th>
              <td>
                <span>
                  {{
                    getText(
                      jibaisekiList,
                      Number(syaryoDetail.syaryo_MEIHEN_JIBAISEKI_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>自動車税種別割額</span></th>
              <td>
                <span>
                  {{
                    numberWithDelimiter(syaryoDetail.syaryo_MEIHEN_JIDOSYA_ZEI)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>環境性能割額</span></th>
              <td>
                <span>
                  {{
                    numberWithDelimiter(
                      syaryoDetail.syaryo_MEIHEN_JIDOSYA_SYUTOKU_ZEI
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isMeihen && !isLease">
              <th><span>重量税額</span></th>
              <td>
                <span>
                  {{
                    numberWithDelimiter(syaryoDetail.syaryo_MEIHEN_JYURYOU_ZEI)
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>車両 備考</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_BIKO }}</span>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <h4
        class="page-sub-title pl-2 pl-md-4 mt-5"
        id="history-detail-option-title"
      >
        オプション
      </h4>
      <section id="history-detail-option">
        <div class="section-child">
          <table
            v-if="syaryoDetail.syaryo_ETC_SETUP_FLG !== null"
            class="table"
          >
            <tr>
              <th><span>ETC車載器セットアップのご希望</span></th>
              <td>
                <span>
                  {{ convETCHopeFlg(syaryoDetail.syaryo_ETC_SETUP_FLG) }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_ETC_SETUP_FLG !== null &&
                Number(syaryoDetail.syaryo_ETC_SETUP_FLG)
              "
            >
              <th><span>ETC車載器管理番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_ETC_KANRI_BANGO }}</span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_ETC_SETUP_FLG !== null &&
                Number(syaryoDetail.syaryo_ETC_SETUP_FLG)
              "
            >
              <th><span>ETC型式登録番号</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_ETC_TOUROKU_BANGO }}</span>
              </td>
            </tr>
          </table>

          <table
            v-if="syaryoDetail.syaryo_SYAKOSYO_JYURYO_FLG !== null"
            class="table mt-2"
          >
            <tr>
              <th><span>車庫証明申請受領のご希望</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.syaryo_SYAKOSYO_JYURYO_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_SYAKOSYO_JYURYO_KBN !== null &&
                syaryoDetail.syaryo_SYAKOSYO_JYURYO_KBN
              "
            >
              <th><span>車庫証明申請書類</span></th>
              <td>
                <span v-if="isMeihen && isLease">
                  {{
                    getText(
                      syakosyoJyuryoKbn,
                      Number(syaryoDetail.syaryo_SYAKOSYO_JYURYO_KBN)
                    ).replace('ユーザー', '使用者')
                  }}
                </span>
                <span v-else>
                  {{
                    getText(
                      syakosyoJyuryoKbn,
                      Number(syaryoDetail.syaryo_SYAKOSYO_JYURYO_KBN)
                    )
                  }}
                </span>
              </td>
            </tr>
          </table>

          <table
            v-if="syaryoDetail.syaryo_SEISOU_FLG !== null"
            class="table mt-2"
          >
            <tr>
              <th><span>清掃サービス</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.syaryo_SEISOU_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_SEISOU_FLG !== null &&
                Number(syaryoDetail.syaryo_SEISOU_FLG)
              "
            >
              <th><span>清掃内容</span></th>
              <td>
                <span>
                  {{
                    getText(seisoList, Number(syaryoDetail.syaryo_SEISOU_KBN))
                  }}
                </span>
              </td>
            </tr>
          </table>

          <table
            v-if="syaryoDetail.syaryo_HOKAN_FLG !== null"
            class="table mt-2"
          >
            <tr>
              <th><span>保管のご希望</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.syaryo_HOKAN_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
          </table>

          <table v-if="isMeihen && isLease" class="table mt-2">
            <tr>
              <th><span>車庫承諾書取得</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      syaryoDetail.syaryo_SYAKO_SYODAKUSYO_FLG
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>承諾書の取寄せ先</span></th>
              <td>
                <span>
                  {{
                    getText(
                      syakoSyodakusyoToriyoseList,
                      syaryoDetail.syaryo_SYAKO_SYODAKUSYO_TORIYOSE_FLG
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>契約者名</span></th>
              <td>
                <span>
                  {{
                    syaryoDetail.syaryo_SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>駐車場名</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_CHUSYAJYO_MEI }}
                </span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>駐車場番号</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO }}
                </span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>住所</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.syaryo_SYAKO_SYODAKUSYO_YUBIN1 &&
                    syaryoDetail.syaryo_SYAKO_SYODAKUSYO_YUBIN2
                  "
                >
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_YUBIN1 }}-{{
                    syaryoDetail.syaryo_SYAKO_SYODAKUSYO_YUBIN2
                  }}
                  <br />
                </span>
                <span v-if="syaryoDetail.syaryo_SYAKO_SYODAKUSYO_TODO_MEI">
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_TODO_MEI }}
                </span>
                <span v-if="syaryoDetail.syaryo_SYAKO_SYODAKUSYO_SHIKU_MEI">
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_SHIKU_MEI }}
                </span>
                <span v-if="syaryoDetail.syaryo_SYAKO_SYODAKUSYO_BANCHI">
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_BANCHI }}
                </span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>TEL</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_TEL }}</span>
              </td>
            </tr>
            <tr v-if="isSyakoSyodakusyo">
              <th><span>取寄せ先情報</span></th>
              <td>
                <span>
                  {{ syaryoDetail.syaryo_SYAKO_SYODAKUSYO_TORIYOSE }}
                </span>
              </td>
            </tr>
          </table>

          <table
            v-if="syaryoDetail.syaryo_JYUMINHYO_DAIKO_FLG !== null"
            class="table mt-2"
          >
            <tr>
              <th><span>住民票取得代行のご希望</span></th>
              <td>
                {{
                  getText(
                    yesNoHopeList,
                    Number(syaryoDetail.syaryo_JYUMINHYO_DAIKO_FLG)
                  )
                }}
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_JYUMINHYO_DAIKO_FLG">
              <th><span>生年月日</span></th>
              <td>
                <span v-if="syaryoDetail.syaryo_JYUMINHYO_DAIKO_YEAR">
                  {{
                    `${syaryoDetail.syaryo_JYUMINHYO_DAIKO_YEAR}年${syaryoDetail.syaryo_JYUMINHYO_DAIKO_MONTH}月${syaryoDetail.syaryo_JYUMINHYO_DAIKO_DAY}日`
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_JYUMINHYO_DAIKO_FLG">
              <th><span>住民票と登録地が異なりますか？</span></th>
              <td>
                <span>
                  {{
                    getText(yesNoFumeiList, syaryoDetail.syaryo_JYUMINHYO_FLG)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="syaryoDetail.syaryo_JYUMINHYO_FLG === 1">
              <th><span>住民票 住所</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.syaryo_JYUMINHYO_YUBIN1 &&
                    syaryoDetail.syaryo_JYUMINHYO_YUBIN2
                  "
                >
                  {{ syaryoDetail.syaryo_JYUMINHYO_YUBIN1 }}-{{
                    syaryoDetail.syaryo_JYUMINHYO_YUBIN2
                  }}
                  <br />
                </span>
                <span>
                  {{ syaryoDetail.syaryo_JYUMINHYO_TODO_MEI
                  }}{{ syaryoDetail.syaryo_JYUMINHYO_SHIKU_MEI
                  }}{{ syaryoDetail.syaryo_JYUMINHYO_BANCHI }}
                </span>
              </td>
            </tr>
          </table>

          <table
            v-if="syaryoDetail.syaryo_SYAKENSYO_SAIHAKKO_FLG !== null"
            class="table mt-2"
          >
            <tr>
              <th><span>車検証再発行のご希望</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      syaryoDetail.syaryo_SYAKENSYO_SAIHAKKO_FLG
                    )
                  }}
                </span>
              </td>
            </tr>
          </table>

          <table
            v-if="syaryoDetail.syaryo_NUMBER_PLATE_FLG !== null"
            class="table mt-2"
          >
            <tr>
              <th><span>ナンバープレート別送サービスのご希望</span></th>
              <td>
                <span>
                  {{
                    getText(
                      yesNoHopeList,
                      Number(syaryoDetail.syaryo_NUMBER_PLATE_FLG)
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_NUMBER_PLATE_FLG !== null &&
                Number(syaryoDetail.syaryo_NUMBER_PLATE_FLG)
              "
            >
              <th><span>名称（ナンバープレート）</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_NUMBER_PLATE_MEI }}</span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_NUMBER_PLATE_FLG !== null &&
                Number(syaryoDetail.syaryo_NUMBER_PLATE_FLG)
              "
            >
              <th><span>住所（ナンバープレート）</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.syaryo_NUMBER_PLATE_YUBIN1 &&
                    syaryoDetail.syaryo_NUMBER_PLATE_YUBIN2
                  "
                >
                  {{ syaryoDetail.syaryo_NUMBER_PLATE_YUBIN1 }}-{{
                    syaryoDetail.syaryo_NUMBER_PLATE_YUBIN2
                  }}
                  <br />
                </span>
                <span>
                  {{ syaryoDetail.syaryo_NUMBER_PLATE_TODO_MEI
                  }}{{ syaryoDetail.syaryo_NUMBER_PLATE_SHIKU_MEI
                  }}{{ syaryoDetail.syaryo_NUMBER_PLATE_BANCHI }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                syaryoDetail.syaryo_NUMBER_PLATE_FLG !== null &&
                Number(syaryoDetail.syaryo_NUMBER_PLATE_FLG)
              "
            >
              <th><span>TEL（ナンバープレート）</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_NUMBER_PLATE_SAKI_TEL }}</span>
              </td>
            </tr>
          </table>

          <table class="table mt-2">
            <tr>
              <th><span>その他ご要望</span></th>
              <td>
                <span>{{ syaryoDetail.syaryo_YOUBOU }}</span>
              </td>
            </tr>
          </table>

          <table v-if="irekaeSyamei" class="table mt-2">
            <tr>
              <th><span>下取/入れ替え車両</span></th>
              <td>
                <span>
                  <b-link @click="search(irekaeId)">
                    {{ irekaeSyamei }}
                  </b-link>
                </span>
              </td>
            </tr>
          </table>
        </div>
      </section>
      {{ toggleDisplayOfOptions() }}

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">請求先</h4>
      <section id="history-detail-seikyu">
        <div class="section-child">
          <table
            v-if="!Number(syaryoDetail.jyucyu_SKS_DIRECT_FLG)"
            class="table"
          >
            <tr>
              <th><span>請求先</span></th>
              <td><span>貴社宛</span></td>
            </tr>
          </table>
          <table v-else class="table">
            <tr>
              <th><span>会社名</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_SKS_KAISYA }}</span>
              </td>
            </tr>
            <tr>
              <th><span>担当部署</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_SKS_BUSYO }}</span>
              </td>
            </tr>
            <tr>
              <th><span>住所</span></th>
              <td>
                <span
                  v-if="
                    syaryoDetail.jyucyu_SKS_YUBIN1 &&
                    syaryoDetail.jyucyu_SKS_YUBIN2
                  "
                >
                  {{ syaryoDetail.jyucyu_SKS_YUBIN1 }}-{{
                    syaryoDetail.jyucyu_SKS_YUBIN2
                  }}
                  <br />
                </span>
                <span>
                  {{ syaryoDetail.jyucyu_SKS_TODO
                  }}{{ syaryoDetail.jyucyu_SKS_SHIKU_MEI
                  }}{{ syaryoDetail.jyucyu_SKS_JYUSYO1 }}
                </span>
              </td>
            </tr>
            <tr>
              <th><span>担当者</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_SKS_TANTO_MEI }}</span>
              </td>
            </tr>
            <tr>
              <th><span>TEL</span></th>
              <td>
                <span>{{ syaryoDetail.jyucyu_SKS_TEL }}</span>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <!--
      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">変更履歴</h4>
      <section id="history-update-list">
        <div class="py-2 bg-gray">
          <md-table v-if="histories.length" v-model="histories" md-sort="KOSHIN_NICHIJI" md-sort-order="desc" md-card class="mx-2 p-2 bg-gray">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="日時" md-sort-by="KOSHIN_NICHIJI" :class="{'bg-blue white': isMobile}">
                <span v-if="!isMobile">{{ dateFormat(item.KOSHIN_NICHIJI) }}</span>
                <div v-else class="row"><p class="col-4 p-0 bold">日時</p>
                  <p class="col-8 p-0">{{ item.KOSHIN_NICHIJI }}</p></div></md-table-cell>
                <md-table-cell md-label="変更履歴" md-sort-by="STATUS">
                  <span v-if="!isMobile">{{ convHistoryStatus(item.STATUS) }}</span>
                  <div v-else class="row"><p class="col-4 p-0 bold blue">変更履歴</p>
                    <p class="col-8 p-0">{{ convHistoryStatus(item.STATUS) }}</p></div></md-table-cell>
                <md-table-cell md-label="変更者" md-sort-by="KOSHIN_MEI">
                  <span v-if="!isMobile">{{ item.KOSHIN_MEI }}</span>
                  <div v-else class="row"><p class="col-4 p-0 bold blue">変更者</p>
                    <p class="col-8 p-0">{{ item.KOSHIN_MEI }}</p></div></md-table-cell>
            </md-table-row>
          </md-table>
          <div v-else class="bg-gray text-center my-5 bold">
            該当データがありません。
          </div>
        </div>
      </section>
-->
      <div class="text-center mt-3 mr-3 mr-md-0">
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
          @click="back()"
        >
          もどる
        </md-button>
      </div>
    </div>

    <!-- モーダル -->
    <md-dialog
      :md-active.sync="showBreakDownDialog"
      class="new w-600"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>料金内訳</md-dialog-title>
      <div class="py-2 px-4">
        <label class="col-md-4 mt-3 px-0"><strong>通常</strong></label>
        <div>
          <div class="row" v-for="u in uchiwakeDetail.normal" :key="u.id">
            <label class="col-8">{{ u.NAME }}</label>
            <span class="col-4">{{ separateComma(u.RYOKIN) }} 円</span>
          </div>
        </div>
        <label class="col-md-4 mt-3 px-0"><strong>オプション</strong></label>
        <div>
          <div class="row" v-for="u in uchiwakeDetail.option" :key="u.id">
            <label class="col-8">{{ u.NAME }}</label>
            <span class="col-4">{{ separateComma(u.RYOKIN) }} 円</span>
          </div>
        </div>
        <div class="mt-5">
          <div class="row">
            <label class="col-8"><strong>合計</strong></label>
            <span class="col-4">
              {{
                uchiwakeDetail.gassanryokin
                  ? separateComma(uchiwakeDetail.gassanryokin)
                  : 0
              }}
              円
            </span>
          </div>
        </div>
      </div>
      <div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showBreakDownDialog = false">
            閉じる
          </md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      :md-active.sync="isErrDialog"
      md-title=""
      :md-content="errMessage"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="false"
      @md-confirm="gotoInquiry"
    />
  </div>
</template>

<script>
import YusouKibouMixin from '@/components/mixin/history/YusouKibouMixin'
import Constant from '@/const'
import {isSyaryoStatusAfterAdjusting} from '@/constants/syaryoStatus'
import {getYusouKibouBiTypeByValue} from '@/constants/yusouKibouBiType'
import {getYusouKibouJikanTypeByValue} from '@/constants/yusouKibouJikanType'
import jQuery from 'jquery'
import {scroller} from 'vue-scrollto/src/scrollTo'
import Mixin from '../mixin/Mixin'

const $ = jQuery
const firstScrollTo = scroller()

export default {
  name: 'Detail',
  mixins: [Mixin, YusouKibouMixin],
  data: () => ({
    errMessage: '',
    cancelId: null,
    isErrDialog: false,
    showBreakDownDialog: false,
    isCancelConfirm: false,
    isCanceled: false,
    syaryoDetail: {},
    uchiwakeDetail: [],
    histories: [],
    status: Constant.ORDER.STATUS,
  }),
  created() {
    this.search(this.$route.params.id)
  },

  methods: {
    /** データを取得する */
    async search(syaryoId) {
      this.spinerOn()
      await this.$store
        .dispatch('history/detail', {
          syaryo_id: syaryoId,
          JYUCYU_SHIKI_CD: this.getShikiCd,
        })
        .then((res) => {
          this.syaryoDetail = res.data[0]
          this.syaryoDetail.hikitoriyoteibi = null
          if (isSyaryoStatusAfterAdjusting(this.syaryoDetail.syaryo_SYARYO_STATUS)) {
            this.syaryoDetail.hikitoriyoteibi = this.dateFormat(this.syaryoDetail.syaryo_HIKITORI_YOTEI_BI)
            if (this.syaryoDetail.syaryo_HIKITORI_YOTEI_BI_SUFFIX) {
              this.syaryoDetail.hikitoriyoteibi += ' ' + this.syaryoDetail.syaryo_HIKITORI_YOTEI_BI_SUFFIX
            }
          }

          this.syaryoDetail.nosyayoteibi = null
          if (isSyaryoStatusAfterAdjusting(this.syaryoDetail.syaryo_SYARYO_STATUS)) {
            this.syaryoDetail.nosyayoteibi = this.dateFormat(this.syaryoDetail.syaryo_NOSYA_YOTEI_BI)
            if (this.syaryoDetail.syaryo_NOSYA_YOTEI_BI_SUFFIX) {
              this.syaryoDetail.nosyayoteibi += ' ' + this.syaryoDetail.syaryo_NOSYA_YOTEI_BI_SUFFIX
            }
          }
          this.histories = res.data[1]
          firstScrollTo('#history-detail')
        })
        .catch((err) => {
          this.errMessage = err.message
          this.isErrMessage = true
          this._alert(this.errMessage, false)
        })
      this.spinerOff()
      this.scroll('clear')
    },

    back() {
      this.$router.push({
        name: 'HistoryIndex',
        params: { paginate: this.$route.params.paginate },
      })
    },
    toggleDisplayOfOptions() {
      // オプションが1件もないときは非表示
      const optSection = $('#history-detail-option')
      if (!optSection.find('tr').length) {
        optSection.prev('h4').hide()
        optSection.hide()
      } else {
        optSection.prev('h4').show()
        optSection.show()
      }
    },
    orderCancel() {
      // ハコボーくんキャンセルAPIはapi側から叩く
      if (this.isSpinerDisplay()) {
        // return
      } else {
        this.spinerOn() // Show spinner.
        this.$store
          .dispatch('history/cancelJyucyuSyaryo', {
            id: this.syaryoDetail.syaryo_ID,
            iraiid: this.syaryoDetail.syaryo_IRAI_JYUCHU_ID,
            meihen: this.syaryoDetail.jyucyu_MEIHEN_FLG,
          })
          .then((res) => {
            if (res.data.result > 0) {
              this.spinerOff() // Close spinner.
              this.scroll('clear')
              this._alert(res.data.message, false)
              return
            }
            this.syaryoDetail.syaryo_SYARYO_STATUS = 9
            this.spinerOff() // Close spinner.
            this.scroll('clear')
            this.isCanceled = true
          })
          .catch((err) => {
            this.errMessage = this.getHcbApiErrorMessage(err.message)
            this.isErrDialog = true
            this.spinerOff()
            this.scroll('clear')
          })
      }
    },
    getUchiwake(syaryoId) {
      this.spinerOn() // Show spinner.
      this.$store
        .dispatch('history/uchiwake', {
          syaryo_id: syaryoId,
          JYUCYU_SHIKI_CD: this.getShikiCd,
        })
        .then((res) => {
          this.uchiwakeDetail = res.data
          this.spinerOff() // Close spinner.
          this.scroll('clear')
          this.showBreakDownDialog = true
        })
        .catch((err) => {
          this.errMessage = err.message
          this.isErrMessage = true
          this._alert(this.errMessage, false) // test
          this.spinerOff() // Close spinner.
          this.scroll('clear')
        })
    },
  },
  computed: {
    /** 名変輸送か判定 */
    isMeihen() {
      return Number(this.syaryoDetail.jyucyu_MEIHEN_FLG)
    },

    /** 車庫承諾書取得か判定 */
    isSyakoSyodakusyo() {
      return (
        this.isMeihen &&
        this.isLease &&
        this.syaryoDetail.syaryo_SYAKO_SYODAKUSYO_FLG
      )
    },

    isHikitoriMaster() {
      return this.syaryoDetail.jyucyu_HIKITORI_PLACE_TYPE === 'torokubasyo'
    },
    isHikitoriDirect() {
      return this.syaryoDetail.jyucyu_HIKITORI_PLACE_TYPE === 'direct'
    },
    isNosyaDirect() {
      return this.syaryoDetail.jyucyu_NOSYA_PLACE_TYPE === 'direct'
    },
    isNosyaMaster() {
      return this.syaryoDetail.jyucyu_NOSYA_PLACE_TYPE === 'torokubasyo'
    },
    isEditTorihiki() {
      return !this.getShikiCd
    },
    getShikiCd() {
      return this.$store.state.history.JYUCYU_SHIKI_CD
    },

    /** 入替車両名 */
    irekaeSyamei() {
      let syamei = this.syaryoDetail.syaryo_CHILD_IREKAE_SYARYO_MEI
      if (!syamei) syamei = this.syaryoDetail.syaryo_PARENT_IREKAE_SYARYO_MEI
      return syamei
    },

    /** 入替車両ID */
    irekaeId() {
      let id = this.syaryoDetail.syaryo_IREKAE_SYARYO_ID
      if (!id) id = this.syaryoDetail.syaryo_CHILD_IREKAE_SYARYO_ID
      return id
    },

    /** 引取オークション表示フラグ */
    isHikitoriAA() {
      return !this.isLease && Number(this.syaryoDetail.jyucyu_HIKITORI_AA_FLG)
    },

    /** 納車オークション表示フラグ */
    isNosyaAA() {
      return !this.isLease && Number(this.syaryoDetail.jyucyu_NOSYA_AA_FLG)
    },

    /** 車両状態 */
    conditions() {
      return this.syaryoDetail.syaryo_CAR_CONDITIONS
        ? JSON.parse(this.syaryoDetail.syaryo_CAR_CONDITIONS)
        : {}
    },

    /** 引取希望日種別 */
    hikitoriKibouBiType() {
      return this.syaryoDetail.jyucyu_HIKITORI_KIBOU_BI_TYPE ? getYusouKibouBiTypeByValue(this.syaryoDetail.jyucyu_HIKITORI_KIBOU_BI_TYPE).label : ''
    },

    /** 引取希望時間 */
    hikitoriKibouJikanType() {
      return this.syaryoDetail.jyucyu_HIKITORI_KIBOU_JIKAN_TYPE ? getYusouKibouJikanTypeByValue(this.syaryoDetail.jyucyu_HIKITORI_KIBOU_JIKAN_TYPE).label : ''
    },

    /** 納車希望日種別 */
    nosyaKibouBiType() {
      return this.syaryoDetail.jyucyu_NOSYA_KIBOU_BI_TYPE ? getYusouKibouBiTypeByValue(this.syaryoDetail.jyucyu_NOSYA_KIBOU_BI_TYPE).label : ''
    },

    /** 納車希望時間 */
    nosyaKibouJikanType() {
      return this.syaryoDetail.jyucyu_NOSYA_KIBOU_JIKAN_TYPE ? getYusouKibouJikanTypeByValue(this.syaryoDetail.jyucyu_NOSYA_KIBOU_JIKAN_TYPE).label : ''
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'

table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
#brakedown-modal
  @extend.base_modal
  font-size: 18px
  width: $baseWidth * 0.4
</style>



// WEBPACK FOOTER //
// src/components/history/Detail.vue